export enum ScenePath {
  Objecto = 'objecto',
  Anatomo = 'anatomo',
}
